import React from "react";
import { Link, useLocation } from "react-router-dom";

const MenuClient = () => {
  const location = useLocation();

  const links = [
    { path: "/banque/portefeuille", label: "Portefeuille", icon: "🏦" },
    { path: "/banque/virement", label: "Virement", icon: "💸" },
    { path: "/banque/carte", label: "Carte", icon: "💳" },
    { path: "/banque/compte", label: "Compte", icon: "👤" },
  ];

  return (
    <nav style={styles.menu}>
      {links.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <Link
            key={item.path}
            to={item.path}
            style={{
              ...styles.link,
              background: isActive
                ? "linear-gradient(135deg, #334155, #1E293B)"
                : "transparent",
              color: isActive ? "#FFFFFF" : "#94A3B8",
              transform: isActive ? "scale(1.05)" : "scale(1)",
              boxShadow: isActive
                ? "0 4px 12px rgba(0, 0, 0, 0.4)"
                : "none",
            }}
          >
            <div style={styles.icon}>{item.icon}</div>
            <div style={styles.label}>{item.label}</div>
          </Link>
        );
      })}
    </nav>
  );
};

const styles = {
  menu: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(30, 41, 59, 0.85)", // bluegray-800 transparent
    backdropFilter: "blur(12px)",
    padding: "12px 0",
    borderTop: "1px solid rgba(148, 163, 184, 0.3)", // bluegray-400
    boxShadow: "0 -2px 10px rgba(0,0,0,0.3)",
    zIndex: 1000,
  },
  link: {
    textDecoration: "none",
    textAlign: "center",
    fontSize: "12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    fontWeight: "600",
    color: "#94A3B8",
    padding: "8px 10px",
    borderRadius: "12px",
    transition: "all 0.25s ease",
  },
  icon: {
    fontSize: "20px",
  },
  label: {
    fontSize: "11px",
    letterSpacing: "0.3px",
  },
};

export default MenuClient;
